
// Class
const Storage = require ('./storage').default;
const PathLocation = require ('./pathLocation').default;
const DataExtract = require ('./dataExtract').default;
const Cookie = require ('./cookies').default;
const Libraries = require ('./libraries').default;
const DeviceDetect = require ('./deviceDetect').default;
const HttpRequest = require ('./httpRequest').default;
const Elements = require ('./elements').default;
const Utils = require ('./utils').default;
const OAuth = require ('./oauth').default;

// Declare Functions in Custom Core
mmkt.core.storage = new Storage();
mmkt.core.pathLocation = new PathLocation();
mmkt.core.dataExtract = new DataExtract();
mmkt.core.cookie = new Cookie();
mmkt.core.libraries = new Libraries();
mmkt.core.detect = new DeviceDetect();
mmkt.core.httpRequest = new HttpRequest();
mmkt.core.utils = new Utils();
mmkt.core.elements = new Elements();
mmkt.core.oauth = new OAuth();
mmkt.core.md5 = require('md5')